import { Component } from "@angular/core";
import { FieldType } from "./field.type";

@Component({
  selector: "kreform-group",
  template: `
    <kreform-field *ngFor="let f of field.fieldGroup" [field]="f"></kreform-field>
    <ng-content></ng-content>
  `,
  host: {
    "[class]": 'field.fieldGroupClassName || ""'
  }
})
export class KreFormGroup extends FieldType {
  defaultOptions = {
    defaultValue: {}
  };
}
